import * as mt from "./mutation-types";
import { FarmsState } from "./types";
import { Farm, FarmListRow, FarmListFilter } from "@/api/farms/types";

interface FarmsPayload {
  farms: Farm[];
}

interface FarmRowsPayload {
  farmList: FarmListRow[];
}

interface FarmFilterPayload {
  filter: FarmListFilter;
}

const farmListFilter = '_farm_list_filter';

export default {
  [mt.CLEAR_FARMS](state: FarmsState) {
    state.farmsContext = [];
    state.status = '';
  },
  [mt.FARMS_REQUEST](state: FarmsState) {
    state.farmsContext = [];
    state.status = "fetching:farms";
  },
  [mt.FARMS_REQUEST_SUCCESS](state: FarmsState, { farms }: FarmsPayload) {
    state.farmsContext = farms;
    state.status = "fetch:farms";
  },

  [mt.FARMS_REQUEST_ERROR](state: FarmsState) {
    state.status = "error";
  },
  [mt.CREATE_FARMS_REQUEST](state: FarmsState) {
    state.createStatus = "submitting:farm";
  },
  [mt.CREATE_FARMS_SUCCESS](state: FarmsState) {
    state.createStatus = "fetch:farm";
  },
  [mt.CREATE_FARMS_FAILURE](state: FarmsState) {
    state.createStatus = "error:farm";
  },

  [mt.FARM_DELETE](state: FarmsState) {
    state.deleteStatus = "deleting:farm";
  },
  [mt.FARM_DELETE_SUCCESS](state: FarmsState) {
    state.deleteStatus = "deleted:farm";
  },
  [mt.FARM_DELETE_ERROR](state: FarmsState) {
    state.deleteStatus = "error:farm";
  },
  [mt.FARM_LIST_CLEAR](state: FarmsState) {
    state.farmListContext = [];
    state.farmListStatus = '';
  },
  [mt.FARM_LIST_REQUEST](state: FarmsState) {
    state.farmListStatus = "fetching:farm-list";
  },
  [mt.FARM_LIST_SUCCESS](state: FarmsState, { farmList }: FarmRowsPayload) {
    state.farmListContext = farmList;
    state.farmListStatus = "fetch:farm-list";
  },

  [mt.FARM_LIST_ERROR](state: FarmsState) {
    state.farmListContext = []
    state.farmListStatus = "error:farm-list";
  },

  [mt.FARM_LIST_FILTER_PERSIST] (state: FarmsState, { filter } : FarmFilterPayload) {
    try {
      localStorage.setItem(farmListFilter, JSON.stringify(filter));
      state.farmListFilter = filter;
    } catch {}
  },
  [mt.FARM_LIST_FILTER_CLEAR] (state: FarmsState) {
    state.farmListFilter = null as unknown as FarmListFilter;
    localStorage.removeItem(farmListFilter);
  },
};
